import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./Language";
import reportWebVitals from './reportWebVitals';
import { MyProvider } from './Context/MyProvider';
import { BrowserRouter } from 'react-router-dom';

import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";

let agoraClient = null;
try {
  agoraClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
} catch (error) {
  console.error("Agora init skipped", error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const appTree = (
  <React.StrictMode>
    <BrowserRouter>
      <MyProvider>
        <App />
      </MyProvider>
    </BrowserRouter>
  </React.StrictMode>
);

root.render(
  agoraClient
    ? <AgoraRTCProvider client={agoraClient}>{appTree}</AgoraRTCProvider>
    : appTree
);

reportWebVitals();
